import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import { UserStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Enum

export enum CustomerTransactionEnum {
  debt = 'debt',
  settled = 'settled',
}

export enum CustomerTypeEnum {
  individual = 'individual',
  corporate = 'corporate',
}

export enum CustomerContactTypeEnum {
  email = 'email',
  phone = 'phone',
}

// Model

export class CustomerBillingModel {
  id: string;
  name: string;
  phone?: string | null;
  phone_2?: string | null;
  address: string;
  bank?: string | null;

  @Expose({ name: 'account_number' })
  accountNumber?: string | null;
}

export class CustomerSystemModel {
  @Expose({ name: 'due_period' })
  @Type(() => Number)
  duePeriod: number;

  @Expose({ name: 'transaction_limit' })
  @Type(() => Number)
  transactionLimit?: number | null;

  @Expose({ name: 'is_transaction_limited' })
  @Type(() => Boolean)
  isTransactionLimited: boolean;

  @Expose({ name: 'remaining_transaction_quota' })
  @Type(() => Number)
  remainingTransactionQuota: number;
}

export class CustomerLiteModel extends CommonModel {
  name: string;
  description?: string | null;
  alias?: string | null;
  address: string;
  phone: string;
  phone_2?: string | null;
  email: string;
  title: string | null;
  status: UserStatusEnum;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Type(() => Number)
  balance: number;

  @Type(() => CustomerBillingModel)
  billings: CustomerBillingModel[];

  @Expose({ name: 'has_due_receivables' })
  @Type(() => Boolean)
  hasDueReceivables: boolean;
}

export class CustomerModel extends CustomerLiteModel {
  type: CustomerTypeEnum;
  religion?: string | null;

  @Type(() => CustomerSystemModel)
  system: CustomerSystemModel;
}

export class CustomerSimilarDataModel {
  @Expose({ name: 'has_similar_data' })
  hasSimilarData: boolean;
}

// Input

export type getCustomersInput = {
  params: CommonParamInput;
};

export type getCustomerInput = {
  id: string;
};

export type getCustomerGuestsInput = {
  id: string;
  params: CommonParamInput;
};

export type CustomerContactPersonInput = {
  id?: string;
  type: string;
  detail: string;
  description?: string;
};

export type CustomerBillingInput = {
  id?: string;
  name: string;
  phone: string;
  phone_2: string;
  address: string;
  bank: string;
  accountNumber: string;
};

export type CustomerSaleSystemInput = {
  isTransactionLimited: boolean;
  transactionLimit: number;
  duePeriod: number;
};

export type CustomerMutationInput = {
  // REQUIRED
  address: string;
  name: string;
  title: string | null;
  phone: string;
  phone_2: string;
  email: string;
  type: string;
  billings: CustomerBillingInput[];
  system: CustomerSaleSystemInput;

  // OPTIONAL
  religion: string;
  description: string;
  alias: string;
};

export type CustomerUpdateInput = {
  customerId: string;
  body: CustomerMutationInput;
};

export type CustomerDeleteInput = {
  customerId: string;
  body: {
    action: UserStatusEnum;
  };
};
